var accessories = []

var selectedVariants = []
var firstArrayForFirstError = [];
var secondArrayForFirstError = [];
var firstArrayForSecondError = [];
var secondArrayForSecondError = [];
var exist_in_first_array = false;
var exist_in_second_array = false;
var exist_in_third_array = false;
var exist_in_forth_array = false;

class TemplateProductAccessoriesJS {
    constructor() {
        this.cartElement = document.querySelector('cart-form');  
        // show quantitybox
        if(document.querySelectorAll("[data-add-accessories-btn]").length > 0){
            document.querySelectorAll("[data-add-accessories-btn]").forEach(ele=>{
                ele.addEventListener("click" , (event)=>{
                    this._showQuantityOption(event);
                });
            })
        }
        //update quantity event
        if(document.querySelectorAll("[data-qty-btn]").length > 0){
            document.querySelectorAll("[data-qty-btn]").forEach(ele=>{
                ele.addEventListener("click" , (event)=>{
                    this._updateQuantity(event);
                });
            })
        };
        //checkout btn click
        if(document.querySelectorAll("[data-checkout-btn]").length > 0 ){
            document.querySelectorAll("[data-checkout-btn]").forEach(ele=>{
                ele.addEventListener("click" , (event)=>{
                    event.preventDefault();
                    this._openDrawer(event);
                });
            });
        };

        if(window.globalVariables.cart.items.length > 0){
            window.globalVariables.cart.items.forEach(item=>{
                selectedVariants.push(item.id);
            })
        }

       this._geErrorVariantIds();
        
        if(document.querySelectorAll("[data-skip-btn]").length > 0){
            document.querySelectorAll("[data-skip-btn]").forEach(ele=>{
                ele.addEventListener("click" , (event)=>{
                    event.preventDefault();
                    document.querySelector('[data-cart-drawer]').click();
                })
            })
        }        
    }

    _showQuantityOption(event){
        event.preventDefault();
        let currentEle = event.currentTarget;
        if (currentEle.classList.contains('disabled')) {
           return true;
        } else {    
        let productWrap = currentEle.closest('[data-accessories-wrap]');
        currentEle.classList.add("d-none");
          productWrap.querySelector('[data-accessories-qty-container]').classList.remove('d-none');
          productWrap.querySelector('[data-qty-input]').value = 1;
        //   document.querySelector("[data-checkout-btn]").classList.remove('btn-disabled');
          document.querySelector("[data-checkout-btn]").classList.add('btn-dark');
          let variantId = productWrap.querySelector("[data-qty-input]").getAttribute('data-variant-id');
          const exists = selectedVariants.some(item => item == variantId);
          if (!exists) {
            selectedVariants.push(parseInt(variantId))
        }

        }
          this._checkCombination();
    };

    _updateQuantity(event) {
        event.preventDefault();
        event.stopImmediatePropagation();
    
        let currentEle = event.currentTarget;
        let quantityWrap = currentEle.closest("[data-accessories-qty-container]");
        let quantityInput = quantityWrap.querySelector('[data-qty-input]');
        let variantId = quantityInput.getAttribute("data-variant-id");
        let quantity = parseInt(quantityInput.value);
        let isMinus = currentEle.getAttribute("data-qty-btn") === "minus";
        const exists = selectedVariants.some(item => item == variantId);
        if (!exists) {
            console.log("selectedVariants",selectedVariants)
            selectedVariants.push(parseInt(variantId))
        }
        if (isMinus && quantity > 1) {
            quantityInput.value = --quantity;
        } else if (!isMinus) {
            quantityInput.value = ++quantity;
        }
    
        if (isMinus && quantity === 1) {
            quantityWrap.classList.add("d-none");
            selectedVariants.pop(variantId)
            currentEle.closest("[data-accessories-wrap]")
                .querySelector("[data-add-accessories-btn]").classList.remove("d-none");

        }
         this._checkCombination();
    }

    _openDrawer(event){
        accessories = []
        const mainProductHandleElement = document.querySelector("[main-product-handle]");
        const rawMainProductHandle = mainProductHandleElement ? mainProductHandleElement.getAttribute('main-product-handle') : null;
        const hasValidMainProductHandle = (
            typeof rawMainProductHandle === 'string' &&
            rawMainProductHandle.trim() !== '' &&
            rawMainProductHandle !== 'null' &&
            rawMainProductHandle !== 'undefined'
        );
        const mainProductHandle = hasValidMainProductHandle ? rawMainProductHandle.trim() : null;
        if (document.querySelectorAll("[data-qty-input]").length > 0) {
            document.querySelectorAll("[data-qty-input]").forEach(ele=>{
                let qty  = parseInt(ele.value);
                let addon_id = ele.getAttribute('data-variant-id');
                let Structure_price=  ele.getAttribute("data_structure_price");
                let installation_price = ele.getAttribute("data_assembly_price");
                if (qty > 0 && addon_id != null) {
                    addon_id = parseInt(addon_id);
                    if(document.querySelector("[assembly-product]")){
                    const properties = {
                        _structure_cost:`${Structure_price}`,
                        _assembly_cost:`${installation_price}`
                    };
                    if (mainProductHandle) {
                        properties._main_product_handle = mainProductHandle;
                    }
                    accessories.push({id:parseInt(addon_id) , quantity : qty , properties});
                    }else{
                        const properties = {
                          _bundle_accessory: 'true'
                        };
                        if (mainProductHandle) {
                            properties._main_product_handle = mainProductHandle;
                        }
                        accessories.push({id:parseInt(addon_id) , quantity : qty , properties });
                    }
                    
                }
            });
            if (accessories.length > 0) {
                this.addMultipleProductsToCart(accessories);
            }else{
                document.querySelector('[data-cart-drawer]').click();
            }
        }
        

    }

// Function to add multiple products to the cart
 async addMultipleProductsToCart(products) {
    try {
        let itemArray = products;   
        // Prepare the items to add to the cart
        // const addItems = window.globalVariables.products;
        const body = JSON.stringify({
            items: itemArray,
            sections: `${(window.globalVariables.template === 'cart' ? 'template-cart' : 'component-cart-drawer')},header`
        }); 
        // Add items to the cart
        const response = await fetch(`${routes.cart_add_url}`, { ...Utility.fetchConfig(), body });
        const dataJSON = await response.json();
        if (dataJSON.errors) {
            window.notificationEle.updateNotification('Add to Cart', dataJSON.errors, {
                type: 'error',
                timeout: 5000
            });
            return;
        }
        if (document.querySelector('cart-form')) {
            let cartElement = document.querySelector('cart-form');
            cartElement._updateCart(dataJSON.sections, 'open_drawer');
        } else {
            window.location.href = window.routes.cart_fetch_url;
        }
    } catch (e) {
        window.notificationEle.updateNotification('Error', e, {
            type: 'error',
            timeout: 5000
        });
        console.error(e);
       
    } finally {
        // submitButton.classList.remove('loading');
        // submitButton.removeAttribute('disabled');
       
    }
}

_geErrorVariantIds(){
    if (document.querySelector("[firstErrorMetafield]")) {
       let data = JSON.parse(document.querySelector("[firstErrorMetafield]").innerText);
       data.forEach(item=>{
        firstArrayForFirstError.push(parseInt(item.variant_id));
       });
       
    }
    if (document.querySelector("[firstErrorSecondMetafield]")) {
       let data = JSON.parse(document.querySelector("[firstErrorSecondMetafield]").innerText);
      data.forEach(item=>{
        secondArrayForFirstError.push(parseInt(item.variant_id));
       });
    }
    if (document.querySelector("[secondErrorMetafield]")) {
        let data = JSON.parse(document.querySelector("[secondErrorMetafield]").innerText);
        data.forEach(item=>{
          firstArrayForSecondError.push(parseInt(item.variant_id));
        });
    }
    if (document.querySelector("[secondErrorSecondMetafield]")) {
      let data =  JSON.parse(document.querySelector("[secondErrorSecondMetafield]").innerText);
      data.forEach(item=>{
        secondArrayForSecondError.push(parseInt(item.variant_id));
      });
    }
  }

_checkCombination() {
    if (selectedVariants.length > 0) {
        let exist = {
            first: false,
            second: false,
            third: false,
            fourth: false
        };

        document.querySelector("[frist_error_message]").classList.add("d-none");
        document.querySelector("[second_error_message]").classList.add("d-none");
        document.querySelector("[data-error-wrap]").classList.add("d-none");

        selectedVariants.forEach(item => {
            let variantId = parseInt(item);
            if (firstArrayForFirstError.includes(variantId)) exist.first = true;
            if (secondArrayForFirstError.includes(variantId)) exist.second = true;
            if (firstArrayForSecondError.includes(variantId)) exist.third = true;
            if (secondArrayForSecondError.includes(variantId)) exist.fourth = true;
        });

        if (exist.third && exist.fourth) {
            document.querySelector("[second_error_message]").classList.remove("d-none");
            document.querySelector("[data-error-wrap]").classList.remove("d-none");
        } else if (exist.first && exist.second) {
            document.querySelector("[frist_error_message]").classList.remove("d-none");
            document.querySelector("[data-error-wrap]").classList.remove("d-none");
        }
    }
}

    
  }
  
new TemplateProductAccessoriesJS();